import React from 'react';
import './InputField.scss';

export const InputField = ({
    type,
    name,
    placeholder,
    value,
    onChange,
    required
}) => (
    <input
        className="input-field"
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
    />
);
